//User Auth actions
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_CHECK_JWT = 'USER_CHECK_JWT';
export const USER_PROFILE_UPDATE = 'USER_PROFILE_UPDATE';
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
export const USER_PROFILE_UPDATE_ERROR = 'USER_PROFILE_UPDATE_ERROR';
export const USER_PASSWORD_CHANGE = 'USER_PASSWORD_CHANGE';
export const USER_PASSWORD_CHANGE_SUCCESS = 'USER_PASSWORD_CHANGE_SUCCESS';
export const USER_PASSWORD_CHANGE_ERROR = 'USER_PASSWORD_CHANGE_ERROR';
export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_ERROR = 'UPDATE_USER_ROLE_ERROR';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
export const UPDATE_USER_INFO_ERROR = 'UPDATE_USER_INFO_ERROR';

//Games actions
export const GET_GAMES = 'GET_GAMES';
export const GET_GAMES_SUCCESS = 'GET_GAMES_SUCCESS';
export const GET_GAMES_ERROR = 'GET_GAMES_ERROR';
export const UPDATED_GAMES = 'UPDATED_GAMES';
export const UPDATED_GAMES_SUCCESS = 'UPDATED_GAMES_SUCCESS';
export const UPDATED_MY_GAMES = 'UPDATED_MY_GAMES';
export const UPDATED_MY_GAMES_SUCCESS = 'UPDATED_MY_GAMES_SUCCESS';
export const GET_MY_GAMES = 'GET_MY_GAMES';
export const GET_MY_GAMES_SUCCESS = 'GET_MY_GAMES_SUCCESS';
export const GET_MY_GAMES_ERROR = 'GET_MY_GAMES_ERROR';
export const GET_GAMES_PAGINATED = 'GET_GAMES_PAGINATED';
export const GET_GAMES_BY_DATE = 'GET_GAMES_BY_DATE';
export const GET_GAMES_BY_DATE_SUCCESS = 'GET_GAMES_BY_DATE_SUCCESS';
export const GET_GAMES_BY_DATE_ERROR = 'GET_GAMES_BY_DATE_ERROR';
export const FILTER_GAMES = 'FILTER_GAMES';
export const FILTER_GAMES_SUCCESS = 'FILTER_GAMES_SUCCESS';
export const FILTER_GAMES_ERROR = 'FILTER_GAMES_ERROR';
export const GET_DAILY_SUMMARY = 'GET_DAILY_SUMMARY';
export const GET_DAILY_SUMMARY_SUCCESS = 'GET_DAILY_SUMMARY_SUCCESS';
export const GET_DAILY_SUMMARY_ERROR = 'GET_DAILY_SUMMARY_ERROR';
export const UPDATE_UMP_AVAILABLE_FOR_GAME = 'UPDATE_UMP_AVAILABLE_FOR_GAME';
export const UPDATE_UMP_AVAILABLE_FOR_GAME_SUCCESS = 'UPDATE_UMP_AVAILABLE_FOR_GAME_SUCCESS';
export const UPDATE_UMP_AVAILABLE_FOR_GAME_ERROR = 'UPDATE_UMP_AVAILABLE_FOR_GAME_ERROR';

//Organization actions
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_ERROR = 'GET_ORGANIZATIONS_ERROR';

//Seasons actions
export const GET_SEASONS = 'GET_SEASONS';
export const GET_ALL_SEASONS = 'GET_ALL_SEASONS'
export const GET_ALL_SEASONS_SUCCESS = 'GET_ALL_SEASONS_SUCCESS'
export const GET_SEASONS_SUCCESS = 'GET_SEASONS_SUCCESS';
export const GET_SEASONS_ERROR = 'GET_SEASONS_ERROR';
export const GET_SEASONS_BY_ACTIVE = 'GET_SEASONS_BY_ACTIVE';
export const GET_SEASONS_BY_DISPLAY = 'GET_SEASONS_BY_DISPLAY';
export const CHANGE_USER_SEASON = 'CHANGE_USER_SEASON';
export const CHANGE_USER_SEASON_SUCCESS = 'CHANGE_USER_SEASON_SUCCESS';
export const CHANGE_USER_SEASON_ERROR = 'CHANGE_USER_SEASON_ERROR';
export const UPDATE_SEASON_MAX_DATE = 'UPDATE_SEASON_MAX_DATE';
export const UPDATE_SEASON_MAX_DATE_SUCCESS = 'UPDATE_SEASON_MAX_DATE_SUCCESS';
export const UPDATE_SEASON_MAX_DATE_ERROR = 'UPDATE_SEASON_MAX_DATE_ERROR';
export const UPDATE_SEASON_ACTIVE = 'UPDATE_SEASON_ACTIVE';
export const UPDATE_SEASON_ACTIVE_SUCCESS = 'UPDATE_SEASON_ACTIVE_SUCCESS';
export const UPDATE_SEASON_ACTIVE_ERROR = 'UPDATE_SEASON_ACTIVE_ERROR';
export const UPDATE_SEASON_DISPLAY = 'UPDATE_SEASON_DISPLAY';
export const UPDATE_SEASON_DISPLAY_SUCCESS = 'UPDATE_SEASON_DISPLAY_SUCCESS';
export const UPDATE_SEASON_DISPLAY_ERROR = 'UPDATE_SEASON_DISPLAY_ERROR';
/*export const GET_SEASONS_BY_ACTIVE_SUCCESS = 'GET_SEASONS_BY_ACTIVE_SUCCESS';
export const GET_SEASONS_BY_ACTIVE_ERROR = 'GET_SEASONS_BY_ACTIVE_ERROR';
*/
//Divisions actions
export const GET_DIVISIONS = 'GET_DIVISIONS';
export const GET_DIVISIONS_SUCCESS = 'GET_DIVISIONS_SUCCESS';
export const GET_DIVISIONS_ERROR = 'GET_DIVISIONS_ERROR';
export const GET_SEASON_DIVISIONS = 'GET_SEASON_DIVISIONS';
export const GET_SEASON_DIVISIONS_SUCCESS = 'GET_SEASON_DIVISIONS_SUCCESS';
export const GET_SEASON_DIVISIONS_ERROR = 'GET_SEASON_DIVISIONS_ERROR';

//Team actions
export const GET_TEAMS = 'GET_TEAMS';
export const GET_TEAMS_SUCCESS = 'GET_TEAMS_SUCCESS';
export const GET_TEAMS_ERROR = 'GET_TEAMS_ERROR';
export const GET_TEAMS_VOLUNTEERING = 'GET_TEAMS_VOLUNTEERING';
export const GET_TEAMS_VOLUNTEERING_SUCCESS = 'GET_TEAMS_VOLUNTEERING_SUCCESS';
export const GET_TEAMS_VOLUNTEERING_ERROR = 'GET_TEAMS_VOLUNTEERING_ERROR';
export const UPDATE_TEAM_VOLUNTEER = 'UPDATE_TEAM_VOLUNTEER';
export const UPDATE_TEAM_VOLUNTEER_SUCCESS = 'UPDATE_TEAM_VOLUNTEER_SUCCESS';
export const UPDATE_TEAM_VOLUNTEER_ERROR = 'UPDATE_TEAM_VOLUNTEER_ERROR';

//Umpire actions
export const GET_UMP_INFO = 'GET_UMP_INFO';
export const GET_UMP_INFO_SUCCESS = 'GET_UMP_INFO_SUCCESS';
export const GET_UMP_INFO_ERROR = 'GET_UMP_INFO_ERROR';
export const ASSIGN_UMP_TO_GAME = 'ASSIGN_UMP_TO_GAME';
export const ASSIGN_UMP_TO_GAME_SUCCESS = 'ASSIGN_UMP_TO_GAME_SUCCESS';
export const ASSIGN_UMP_TO_GAME_ERROR = 'ASSIGN_UMP_TO_GAME_ERROR';
export const REMOVE_UMP_FROM_GAME = 'REMOVE_UMP_FROM_GAME';
export const REMOVE_UMP_FROM_GAME_SUCCESS = 'REMOVE_UMP_FROM_GAME_SUCCESS';
export const REMOVE_UMP_FROM_GAME_ERROR = 'REMOVE_UMP_FROM_GAME_ERROR';
export const GET_UMPIRES_LIST = 'GET_UMPIRES_LIST';
export const GET_UMPIRES_LIST_SUCCESS = 'GET_UMPIRES_LIST_SUCCESS';
export const GET_UMPIRES_LIST_ERROR = 'GET_UMPIRES_LIST_ERROR';
export const UPDATE_UMP = 'UPDATE_UMP';
export const UPDATE_UMP_SUCCESS = 'UPDATE_UMP_SUCCESS';
export const UPDATE_UMP_ERROR = 'UPDATE_UMP_ERROR';
export const UPDATE_MENTEES = 'UPDATE_MENTEES';
export const UPDATE_MENTEES_SUCCESS = 'UPDATE_MENTEES_SUCCESS';
export const UPDATE_MENTEES_ERROR = 'UPDATE_MENTEES_ERROR';
export const GET_MENTOR_MENTEE_INFO = 'GET_MENTOR_MENTEE_INFO';
export const GET_MENTOR_MENTEE_INFO_SUCCESS = 'GET_MENTOR_MENTEE_INFO_SUCCESS';
export const GET_MENTOR_MENTEE_INFO_ERROR = 'GET_MENTOR_MENTEE_INFO_ERROR';
export const GET_UMPS_NEXT_GAME = 'GET_UMPS_NEXT_GAME';
export const GET_UMPS_NEXT_GAME_SUCCESS = 'GET_UMPS_NEXT_GAME_SUCCESS';
export const GET_UMPS_NEXT_GAME_ERROR = 'GET_UMPS_NEXT_GAME_ERROR';

//Coach actions
export const ADD_COACH_TO_TEAM = 'ADD_COACH_TO_TEAM';
export const ADD_COACH_TO_TEAM_SUCCESS = 'ADD_COACH_TO_TEAM_SUCCESS';
export const ADD_COACH_TO_TEAM_ERROR = 'ADD_COACH_TO_TEAM_ERROR';
export const GET_COACHES_LIST = 'GET_COACHES_LIST';
export const GET_COACHES_LIST_SUCCESS = 'GET_COACHES_LIST_SUCCESS';
export const GET_COACHES_LIST_ERROR = 'GET_COACHES_LIST_ERROR';
export const GET_COACHES_TEAMS = 'GET_COACHES_TEAMS';
export const GET_COACHES_TEAMS_SUCCESS = 'GET_COACHES_TEAMS_SUCCESS';
export const GET_COACHES_TEAMS_ERROR = 'GET_COACHES_TEAMS_ERROR';
export const REMOVE_COACH_FROM_TEAM = 'REMOVE_COACH_FROM_TEAM';
export const REMOVE_COACH_FROM_TEAM_SUCCESS = 'REMOVE_COACH_FROM_TEAM_SUCCESS';
export const REMOVE_COACH_FROM_TEAM_ERROR = 'REMOVE_COACH_FROM_TEAM_ERROR';

//Member actions
export const GET_MEMBERS_LIST = 'GET_MEMBERS_LIST';
export const GET_MEMBERS_LIST_SUCCESS = 'GET_MEMBERS_LIST_SUCCESS';
export const GET_MEMBERS_LIST_ERROR = 'GET_MEMBERS_LIST_ERROR';

//Player actions
export const GET_PLAYERS_LIST = 'GET_PLAYERS_LIST';
export const GET_PLAYERS_LIST_SUCCESS = 'GET_PLAYERS_LIST_SUCCESS';
export const GET_PLAYERS_LIST_ERROR = 'GET_PLAYERS_LIST_ERROR';

//Mentors actions
export const GET_MENTORS_LIST = 'GET_MENTORS_LIST';
export const GET_MENTORS_LIST_SUCCESS = 'GET_MENTORS_LIST_SUCCESS';
export const GET_MENTORS_LIST_ERROR = 'GET_MENTORS_LIST_ERROR';

//Errors actions
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

//Mobile specific actions
export const UPDATE_MOBILE_STATE = 'UPDATE_MOBILE_STATE';
export const UPDATE_MOBILE_STATE_SUCCESS = 'UPDATE_MOBILE_STATE_SUCCESS';
export const UPDATE_MOBILE_STATE_ERROR = 'UPDATE_MOBILE_STATE_ERROR';

//Report actions using Jonathans API
export const GET_SEASON_UMPIRE_DATA = 'GET_SEASON_UMPIRE_DATA';
export const GET_SEASON_UMPIRE_DATA_SUCCESS = 'GET_SEASON_UMPIRE_DATA_SUCCESS';
export const GET_SEASON_UMPIRE_DATA_ERROR = 'GET_SEASON_UMPIRE_DATA_ERROR';
export const GET_YTD_DATA = 'GET_YTD_DATA';
export const GET_YTD_DATA_SUCCESS = 'GET_YTD_DATA_SUCCESS';
export const GET_YTD_DATA_ERROR = 'GET_YTD_DATA_ERROR';

//Report and Statistics actions
export const GET_WHEEL_DATA = 'GET_WHEEL_DATA';
export const GET_WHEEL_DATA_SUCCESS = 'GET_WHEEL_DATA_SUCCESS';
export const GET_WHEEL_DATA_ERROR = 'GET_WHEEL_DATA_ERROR';
export const GET_FULL_SEASON_STATS = 'GET_FULL_SEASON_STATS';
export const GET_FULL_SEASON_STATS_SUCCESS = 'GET_FULL_SEASON_STATS_SUCCESS';
export const GET_FULL_SEASON_STATS_ERROR = 'GET_FULL_SEASON_STATS_ERROR';
export const GET_UMPIRE_STATS = 'GET_UMPIRE_STATS';
export const GET_UMPIRE_STATS_SUCCESS = 'GET_UMPIRE_STATS_SUCCESS';
export const GET_UMPIRE_STATS_ERROR = 'GET_UMPIRE_STATS_ERROR';
export const GET_TEAM_VOLUNTEER_DATA = 'GET_TEAM_VOLUNTEER_DATA';
export const GET_TEAM_VOLUNTEER_DATA_SUCCESS = 'GET_TEAM_VOLUNTEER_DATA_SUCCESS';
export const GET_TEAM_VOLUNTEER_DATA_ERROR = 'GET_TEAM_VOLUNTEER_DATA_ERROR';

//Weather action constants
export const GET_TODAYS_WEATHER = 'GET_TODAYS_WEATHER';
export const GET_TODAYS_WEATHER_SUCCESS = 'GET_TODAYS_WEATHER_SUCCESS';
export const GET_TODAYS_WEATHER_ERROR = 'GET_TODAYS_WEATHER_ERROR';

//SMS action constants
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';



// WEBPACK FOOTER //
// ./src/actions/actionConstants.js